import { getProductFormField } from '../utils';
import Component from './ProductFormValue';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
